import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-300';
  const variants = {
    primary: 'bg-sand hover:bg-sand-dark text-white',
    secondary: 'bg-ink hover:bg-ink-light text-white',
    outline: 'border border-ink text-ink hover:bg-ink hover:text-white'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-47">
      {children}
    </motion.button>;
}